import PageTitle from '@/components/PageTitle';
import { useState } from 'react';
import { PrimaryTabs } from '@components/PrimaryTabs';
import classes from './index.module.css';
import { tabs } from './const';
import StoresInfo from './Tab2';
import CompanyInfo from './Tab1';
import './index.css';

export default function OrgSettings() {
  const [tabIndex, setTabIndex] = useState(0);
  const onTabChange = (_, tab) => {
    setTabIndex(tab);
  };

  return (
    <div className={classes.wrapper}>
      <PageTitle title="Organization settings" />
      <PrimaryTabs tabIndex={tabIndex} onTabChange={onTabChange} tabList={tabs} />
      <div className={classes.content}>
        <div className={classes.main}>
          {tabIndex === 0 && <CompanyInfo />}
          {tabIndex === 1 && <StoresInfo />}
        </div>
      </div>
    </div>
  );
}
